import { useGetLifePolicyEntryQuery, useSaveLifePolicyEntryMutation, useUpdateLifePolicyEntryMutation, useDeleteLifePolicyEntryMutation } from '../../baseApi';

// Custom hooks for LifePolicyEntry
export const useLifePolicyEntryList = (pageNumber = 1, pageSize = 10, filters = {}) => {
  // Support two call styles:
  // 1) Positional: useLifePolicyEntryList(pageNumber, pageSize, filters)
  // 2) Single options object: useLifePolicyEntryList({ pageNumber, pageSize, sortField, ... })
  let args;
  if (typeof pageNumber === 'object' && pageNumber !== null && !Array.isArray(pageNumber)) {
    // Called with an options object as first param
    const {
      pageNumber: pn = 1,
      pageSize: ps = 10,
      ...rest
    } = pageNumber;
    args = { pageNumber: pn, pageSize: ps, ...rest };
  } else {
    args = { pageNumber, pageSize, ...filters };
  }

  return useGetLifePolicyEntryQuery(args);
};

export const useLifePolicyEntryOperations = () => {
  const [saveLifePolicyEntry, { isLoading: saving }] = useSaveLifePolicyEntryMutation();
  const [updateLifePolicyEntry, { isLoading: updating }] = useUpdateLifePolicyEntryMutation();
  const [deleteLifePolicyEntry, { isLoading: deleting }] = useDeleteLifePolicyEntryMutation();
//   const [deleteBulkLifePolicyEntry, { isLoading: LifePolicyEntrydeleting }] = useBulkDeleteLifePolicyEntryMutation();

  return {
    
    saveLifePolicyEntry,
    updateLifePolicyEntry,
    deleteLifePolicyEntry,
    // deleteBulkLifePolicyEntry,
    isProcessing: saving || updating || deleting ,
  };
};
